import classNames from 'classnames';
import {ChangeEvent, ReactElement, useMemo} from 'react';
import {InputOptionsType} from '../../types';
import LockIconSvg from '../LockIconSvg';

interface SingleSelectFieldProps {
  label: string;
  labeledOptions: InputOptionsType;
  name: string;
  value: string | boolean;
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  labelClassName?: string;
  error?: string;
  hidden?: boolean;
  disabled?: boolean;
  props?: React.InputHTMLAttributes<HTMLSelectElement>;
}

export default function SingleSelectField({
  label,
  labelClassName,
  labeledOptions,
  name,
  value,
  onChange,
  error,
  disabled,
  ...props
}: SingleSelectFieldProps): ReactElement {
  const hasError = useMemo(() => !!error, [error]);

  return (
    <label
      className={labelClassName}
      style={{display: props?.hidden ? 'none' : 'block'}}
    >
      <span className="form__element-text">
        {label}
        {disabled && <LockIconSvg />}
      </span>
      <select
        name={name}
        value={String(value)}
        onChange={onChange}
        className={classNames('form__element', {
          'form__element-error': hasError,
        })}
        disabled={disabled}
        {...props}
      >
        {Object.values(labeledOptions).map(({value, label}) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </select>
      {hasError && <p className="error-msg">{error}</p>}
    </label>
  );
}
